import clsx from "clsx";

import { useGetCandidacyCountsByStatus } from "@/hooks/queries";

const CountWithStatus = ({
  className,
  count,
  status,
}: {
  className?: string;
  count: number;
  status: string;
}) => {
  return (
    <div className={clsx("flex flex-col gap-1 p-6", className)}>
      <p className="text-3xl font-semibold text-slate-900">{count}</p>
      <p className="font-medium text-slate-700">{status}</p>
    </div>
  );
};

export const JobCandidacyCountsByStatus = ({
  className,
}: {
  className?: string;
}) => {
  const { data: candidacyCountsByStatus, status } =
    useGetCandidacyCountsByStatus();

  if (status === "pending") {
    // TODO: Loading state.
    return null;
  } else if (status === "error") {
    // TODO: Handle error.
    return null;
  }

  return (
    <div className={clsx("flex items-center", className)}>
      <CountWithStatus
        className="w-full"
        count={candidacyCountsByStatus.MATCHED}
        status="Matched"
      />
      <CountWithStatus
        className="w-full border-l border-slate-200"
        count={candidacyCountsByStatus.INTERVIEW}
        status="Interview"
      />
      <CountWithStatus
        className="w-full border-l border-slate-200"
        count={candidacyCountsByStatus.OFFER}
        status="Offer"
      />
    </div>
  );
};
